// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1NFNS","main":"Header_main__2wrB1","loadingBar":"Header_loadingBar__2BKDy"};